/* global femcare, jwplayer */

/**
 * Video Player Functions
 * Core JWPlayer functionality and event handling
 */

/**
 * Check if JWPlayer is available
 */
femcare.video.checkJWPlayer = function () {
    if (typeof jwplayer === 'function') {
        return Promise.resolve();
    }
    return Promise.reject(new Error('JWPlayer not loaded - ensure script is included in backend'));
};

/**
 * Setup video player events
 */
femcare.video.setupVideoEvents = function (player, $trigger, $wrapper, playerId) {
    // Initialize loop counter and tracking flags
    player._currentPlay = 0;
    player._startFired = false;
    player._firedQ = { 25: false, 50: false, 75: false };

    // Check if GA4 should be disabled (per documentation requirement)
    const config = player.getConfig();
    const submitGA4Data = !(config.autostart === true || config.autostart === 'viewable');

    player.on('ready', () => {
        player._startFired = false;
        player._firedQ = { 25: false, 50: false, 75: false };
    });

    player.on('play', () => {
        if (!player._startFired && submitGA4Data) {
            this.trackVideoEvent('ga4_video_start', player, $trigger);
            player._startFired = true;
        }

        if ($trigger) {
            const $videoContainer = $trigger.closest('.video-inline, .media-hero__video');
            if ($videoContainer.length) {
                $videoContainer.addClass('video-is-playing');
            }
        }

        femcare.shared.pubsub.publish('VIDEO_PLAY', {
            player: player,
            playerId: playerId,
            $trigger: $trigger
        });
    });

    player.on('pause', () => {
        // Remove video-is-playing class from video container element
        if ($trigger) {
            const $videoContainer = $trigger.closest('.video-inline, .media-hero__video');
            if ($videoContainer.length) {
                $videoContainer.removeClass('video-is-playing');
            }
        }

        femcare.shared.pubsub.publish('VIDEO_PAUSE', {
            player: player,
            playerId: playerId,
            $trigger: $trigger
        });
    });

    player.on('complete', () => {
        if ($wrapper && $wrapper.hasClass('video-player-parent--show')) {
            $wrapper.removeClass('video-player-parent--show');
        }

        // Remove video-is-playing class from video container element
        if ($trigger) {
            const $videoContainer = $trigger.closest('.video-inline, .media-hero__video');
            if ($videoContainer.length) {
                $videoContainer.removeClass('video-is-playing');
            }
        }

        if (submitGA4Data) {
            this.trackVideoEvent('ga4_video_complete', player, $trigger);
        }

        // Handle loop limiting (stop after 3 plays)
        player._currentPlay++;
        if (player._currentPlay >= 3) {
            player.stop();
            this.removePlayerFromActive(player);
        } else {
            // Reset flags for next loop if repeating
            if (player.getConfig().repeat) {
                player._firedQ = { 25: false, 50: false, 75: false };
                player._startFired = false;
            }
        }

        femcare.shared.pubsub.publish('VIDEO_COMPLETE', {
            player: player,
            playerId: playerId,
            $trigger: $trigger
        });
    });

    player.on('seek', (evt) => {
        // Skip firing GA4 if user drags slider forward
        const dur = player.getDuration();
        const newPct = (evt.offset * 100) / dur;
        [25, 50, 75].forEach(q => {
            if (newPct >= q) {
                player._firedQ[q] = true;
            }
        });
    });

    player.on('time', (e) => {
        this.trackVideoProgress(e, player, $trigger);
    });

    player.on('error', (e) => {
        console.error('Video player error:', e);

        // Remove video-is-playing class from video container element
        if ($trigger) {
            const $videoContainer = $trigger.closest('.video-inline, .media-hero__video');
            if ($videoContainer.length) {
                $videoContainer.removeClass('video-is-playing');
            }
        }

        this.removePlayerFromActive(player);
    });
};

/**
 * Track video progress milestones
 */
femcare.video.trackVideoProgress = function (event, player, $trigger) {
    // Check if analytics should be submitted (stored during setupVideoEvents)
    const config = player.getConfig();
    const submitGA4Data = !(config.autostart === true || config.autostart === 'viewable');

    if (!submitGA4Data) return;

    const progress = (event.position * 100) / event.duration;

    [25, 50, 75].forEach(q => {
        if (progress >= q && !player._firedQ[q]) {
            this.trackVideoEvent('ga4_video_progress', player, $trigger, q);
            player._firedQ[q] = true;
        }
    });
};

/**
 * Track video events for analytics using dataLayer (GA4 format)
 */
femcare.video.trackVideoEvent = function (eventName, player, $trigger, percent = null) {
    // Initialize dataLayer if not exists
    window.dataLayer = window.dataLayer || [];

    // Get video info
    const playlist = player.getPlaylistItem();
    const currentTime = Math.floor(player.getPosition() || 0);
    const duration = Math.floor(player.getDuration() || 0);
    const videoPercent = percent || (duration > 0 ? Math.floor((currentTime / duration) * 100) : 0);

    // Build GA4 data object matching documentation format
    const ga4Data = {
        video_current_time: currentTime,
        video_duration: duration,
        video_percent: videoPercent,
        video_provider: 'JW Player',
        video_title: playlist?.title || $trigger.attr('data-video-name') || 'Unknown',
        video_url: playlist?.file || 'Unknown',
        visible: player.getViewable ? player.getViewable() : 1
    };

    // Push to dataLayer with proper event format
    window.dataLayer.push({
        event: eventName,
        ga4_data: ga4Data
    });
};